import { Badge } from './ui/badge';
import { CheckCircle, Heart, Feather, Users } from 'lucide-react';

// Ownership and verification badges for businesses
export const OwnershipBadges = ({ 
  isVerified = false,
  womenOwned = false,
  nativeOwned = false,
  bipocOwned = false,
  size = 'default' // 'small', 'default', 'large'
}) => {
  const badges = [];
  
  const sizeClasses = {
    small: 'text-[10px] px-1.5 py-0',
    default: 'text-xs px-2 py-0.5',
    large: 'text-sm px-3 py-1'
  };

  const iconSize = size === 'small' ? 10 : size === 'large' ? 16 : 12;

  if (isVerified) {
    badges.push(
      <Badge 
        key="verified" 
        className={`bg-blue-500/20 text-blue-400 border-blue-500/30 ${sizeClasses[size]}`}
      >
        <CheckCircle size={iconSize} className="mr-1" /> Verified
      </Badge>
    );
  }

  if (womenOwned) {
    badges.push(
      <Badge 
        key="women" 
        className={`bg-pink-500/20 text-pink-400 border-pink-500/30 ${sizeClasses[size]}`}
      >
        <Heart size={iconSize} className="mr-1" /> Women Owned
      </Badge>
    );
  }

  if (nativeOwned) {
    badges.push(
      <Badge 
        key="native" 
        className={`bg-orange-500/20 text-orange-400 border-orange-500/30 ${sizeClasses[size]}`}
      >
        <Feather size={iconSize} className="mr-1" /> Native Owned
      </Badge>
    );
  }

  if (bipocOwned) {
    badges.push(
      <Badge 
        key="bipoc" 
        className={`bg-amber-500/20 text-amber-400 border-amber-500/30 ${sizeClasses[size]}`}
      >
        <Users size={iconSize} className="mr-1" /> BIPOC Owned
      </Badge>
    );
  }

  if (badges.length === 0) return null;

  return <div className="flex flex-wrap gap-1.5">{badges}</div>;
};

// Individual badge components for flexibility
export const VerifiedBadge = ({ size = 'default' }) => (
  <Badge className={`bg-blue-500/20 text-blue-400 border-blue-500/30 ${size === 'small' ? 'text-[10px] px-1.5 py-0' : 'text-xs px-2 py-0.5'}`}>
    <CheckCircle size={size === 'small' ? 10 : 12} className="mr-1" /> Verified
  </Badge>
);

export const WomenOwnedBadge = ({ size = 'default' }) => (
  <Badge className={`bg-pink-500/20 text-pink-400 border-pink-500/30 ${size === 'small' ? 'text-[10px] px-1.5 py-0' : 'text-xs px-2 py-0.5'}`}>
    <Heart size={size === 'small' ? 10 : 12} className="mr-1" /> Women Owned
  </Badge>
);

export const NativeOwnedBadge = ({ size = 'default' }) => (
  <Badge className={`bg-orange-500/20 text-orange-400 border-orange-500/30 ${size === 'small' ? 'text-[10px] px-1.5 py-0' : 'text-xs px-2 py-0.5'}`}>
    <Feather size={size === 'small' ? 10 : 12} className="mr-1" /> Native Owned
  </Badge>
);

export const BIPOCOwnedBadge = ({ size = 'default' }) => (
  <Badge className={`bg-amber-500/20 text-amber-400 border-amber-500/30 ${size === 'small' ? 'text-[10px] px-1.5 py-0' : 'text-xs px-2 py-0.5'}`}>
    <Users size={size === 'small' ? 10 : 12} className="mr-1" /> BIPOC Owned
  </Badge>
);

export default OwnershipBadges;
